export const CONCERN_CATEGORIES = {
  "Body Contours": [
    "Fat Reduction",
    "Cellulite",
    "Body Sculpting",
    "Muscle Tone",
    "Bra Fat",
    "Stubborn Fat",
    "Lack of Muscle Definition",
    "Aging Hands",
    "Hip Dips",
  ],
  "Dental Aesthetics": ["Teeth Whitening", "Dental Aesthetics"],
  "Facial Contours": [
    "Chin & Jawline",
    "Double Chin",
    "Gummy Smile",
    "Smile",
    "Facial Contours",
    "Droopy Eyebrows",
    "Nasolabial Folds",
    "Sunken Temples",
    "Lip Enhancements",
    "Cheek Enhancements",
    "Facial Balancing",
  ],
  Hair: ["Hair Loss", "Hair Removal"],
  Health: [
    "Sick Visit",
    "Immune Support",
    "Mold Toxicity",
    "Nutrition",
    "Acute Illness",
    "Heavy Metal Toxicity",
    "Weight Management",
    "Pediatric Health",
    "Women's Health",
    "Men's Health",
    "Neuropathy",
    "Allergies",
    "Numbness & Tingling",
    "Nausea",
  ],
  "Mental Health": [
    "Mental Health",
    "Insomnia",
    "Anxiety",
    "Depression",
    "Stress Relief",
    "Postpartum Recovery",
    "Psychosomatic & Trauma",
  ],
  "Oral Health": ["Tooth Pain", "Dental Wellness", "Oral Hygiene"],
  "Pain Relief": [
    "Chronic Pain",
    "Inflammation",
    "Discomfort",
    "Migraines",
    "Headaches",
    "Disc Herniation (Bulge)",
    "Plantar Fasciitis",
    "Tennis Elbow",
    "Golfer's Elbow",
    "Knee Pain",
    "Acute Pain",
    "Shoulder Pain",
    "Pinched Nerve",
    "Radiculopathy",
    "Frozen Shoulder",
    "Migraine Relief",
    "Sciatica",
    "Joint Pain",
    "Arthritis",
  ],
  "Skin Clarity": [
    "Acne",
    "Discoloration",
    "Redness",
    "Spider Veins",
    "Stretch Marks",
    "Hyperpigmentation",
    "Melasma",
    "Rosacea",
    "Age Spots",
    "Dark Spots",
    "Tattoo Removal",
    "Sun Damage",
    "Dull Skin",
    "Uneven Skin Tone",
    "Broken Capillaries",
  ],
  "Skin Texture": [
    "Enlarged Pores",
    "Loose Skin",
    "Scars",
    "Skin Rejuvenation",
    "Wrinkles",
    "Anti-aging",
    "Dry Skin",
    "Moles",
    "Varicose Veins",
    "Acne Scars",
    "Sagging Skin",
    "Fine Lines",
    "Cherry Angiomas",
    "Prejuvenation",
    "Volume Loss",
    "Skin Elasticity",
    "Collagen Stimulation",
    "Marionette Lines",
    "Smile Lines",
  ],
  Wellness: [
    "Sexual Wellness",
    "Wellness",
    "Sleep",
    "Hormone Imbalance",
    "Detox",
    "Athletic Recovery",
    "Longevity",
    "Weight Loss",
    "Erectile Dysfunction",
    "Fatigue",
    "Hydration",
    "Low Libido",
    "Low Testosterone",
    "Sexual Dysfunction",
    "Vaginal Dryness",
    "Urinary Incontinence",
    "Skin Irritation",
    "Vaginal Elasticity",
    "Gut Health",
    "Excessive Sweating",
    "Ingrown Hair",
  ],
} as const;

export const GENDER_FILTERED_CONCERNS = {
  "Women's Health": { hiddenIf: "male" },
  "Postpartum Recovery": { hiddenIf: "male" },
  "Men's Health": { hiddenIf: "female" },
  "Erectile Dysfunction": { hiddenIf: "female" },
  "Vaginal Dryness": { hiddenIf: "male" },
  "Vaginal Elasticity": { hiddenIf: "male" },
} as const;

export type ConcernCategoryName = keyof typeof CONCERN_CATEGORIES;
export type GenderFilterRule =
  (typeof GENDER_FILTERED_CONCERNS)[keyof typeof GENDER_FILTERED_CONCERNS];
